<template>
<v-container fluid>
      <v-card outlined flat v-if="countries" max-width="75%" class="mx-auto">
        <v-card-title style="color:#fff;"   primary-title class="primary layout justify-center">
          Registation form
        </v-card-title>
        <v-card-text>
          <v-flex>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field label="Name:" 
                  style="margin:10px"
                  :rules="nameRules"
                  v-model="name"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field label="Surname:" 
                  style="margin:10px"
                  :rules="nameRules"
                  v-model="surname"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-select
                  style="margin:10px"
                  v-model="country"
                  :items="myCountries"
                  label="Country:"
                >Select country</v-select>
              </v-flex>
              <v-flex xs6>
              <v-select
                  style="margin:10px"
                  v-model="lang"
                  :items="myLanguages"
                  label="Environment language:"
                >Select environment language</v-select>
              </v-flex>
            </v-layout>
            <v-layout row wrap align-baseline >
              <v-flex xs4>
                <v-text-field label="Nickname:" 
                  style="margin:10px"
                  v-model="nickName"></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field label="Group/university:" 
                  style="margin:10px"
                  v-model="group"></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-slider
                    style="margin:10px"
                    v-model="age"
                    :rules="rules.age"
                    :label="getAge()"
                    hint="Be honest, please."
                    :min="1940"
                    :max="endYear"
                    thumb-label
                  ></v-slider>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field label="E-mail:" 
                  required
                  style="margin:10px"
                  :rules="emailRules"
                  v-model="email" >
                </v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field label="Password:" v-model="passw"
                  style="margin:10px"
                  :append-icon="show1 ? 'visibility' : 'visibility_off'"
                  :rules="[rules.required, rules.min]"
                  :type="show1 ? 'text' : 'password'"
                  @click:append="show1 = !show1"
                  ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field label="Confirm password:" v-model="confpassw"
                  style="margin:10px"
                  :rules="[rules.required, rules.min]"
                  :type="show1 ? 'text' : 'password'"
                  ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <p align="center" v-if="feedback" style="color: red">{{feedback}}</p>
          </v-flex>
          <v-flex class="text-center">
            <!-- ps: upravene tlacidlo -->
            <v-btn class="white--text" color="success" @click="sendData()">Register</v-btn>
          </v-flex>
        </v-card-text>


      </v-card>
</v-container>
</template>

<script>
import axios from '../../axios-auth.js'

  export default {
    data () {
      return {
        feedback: '', 
        name: '',
        surname : '',
        group: '',
        languages: null,
        age: 0,
        myLanguages: [],
        emailRules: [
          v => !!v || 'E-mail is required',
          v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
         ],
        nameRules: [
            v => !!v || 'The value is required',
            v => (v && v.length >= 2 && v.length <= 40) || 'The value must be 2-40 characters',
          ],          
        lang: '',
        countries: null,
        myCountries: [],
        country: '',
        email: '',
        passw: '',
        confpassw: '',
        nickName: '',
        endYear: 0,
        show1 : false,
        rules: {
          required: value => !!value || 'Required.',
          min: v => v.length >= 5 || 'Min 5 characters'
        },
        grant_type:"password",
        client_id: "2",
        client_secret: "iQuGUAzqc187j7IKQ94tTVJAywHCAzYBGAMTxEtr",
      }
    },
    methods: {
      sendData () {
        this.$store.commit('setFeedback', null)
        this.feedback = null
        if (this.name.length < 2) { 
          this.feedback = "Name is too short." 
          return 
        }
        if (this.surname.length < 2) {
          this.feedback = "Surname is too short."
          return
        }

        if (this.age == 1940) {
          this.feedback = "Please set your age - content is dependent on age too."
          return
        }  

        for(let i = 0; i<this.email.length; i++) {
          let ch = this.email.substring(i,i+1)
          let accepted = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!#$%&.@*+-/=?^_`{|}~'
          if ((accepted.indexOf(ch) > -1)) continue
            this.feedback = "Unsupported character in email address (a-z, A-Z, 0-9, !#$%&*+-/=?^_`{|}~)"
            return
        }

        if (this.email.length < 2) {
          this.feedback = "Email address is missing or too short."
          return
        }          

        if (this.passw != this.confpassw) {
          this.feedback = "Password and confirmation must be match."
          return
        }          

        var _nick = this.nickName
        if (_nick.length < 2) _nick = this.name + " " + this.surname
        var _country = this.countries[this.myCountries.indexOf(this.country)].id
        var _lang = this.languages[this.myLanguages.indexOf(this.lang)].id

        const data = {
          name: this.name,
          surname : this.surname,
          country :  _country,
          lang: _lang,
          email: this.email,
          passw: this.passw,
          nick: _nick,
          group: this.group,
          age: this.age,
        }

        // eslint-disable-next-line
        console.log(data)
        axios.post('/register', data, this.$store.getters.getAxiosConfig)
          .then(() => {
            // login
            const data = {
              email: this.email,
              password: this.passw,
              grant_type: this.grant_type,
              client_id: this.client_id,
              client_secret: this.client_secret,
              username: this.email
            }
            this.$store.dispatch('login', data)
          })
          .catch(error => {
              var str = error.message            
              var _err = str.substring(str.length - 3, str.length)
              if (_err == 401) _err = 'Email "' + this.email + '" is used. Registration was aborted.'
              if (_err == 400) this.feedback = error.message
              else this.feedback = _err
          })
      },
      initData() {
        var d = new Date()
        this.endYear = d.getFullYear()

        this.$store.commit('setFeedback', null)
        axios.get('/languages', this.$store.getters.getAxiosConfig)
        .then((response) => {
          this.languages = response.data
          this.myLanguages = []
          for(let i = 0; i < this.languages.length; i++) {
            this.myLanguages.push( this.languages[i].name)
          }
          this.lang = this.myLanguages[0]
          // eslint-disable-next-line
          // console.log(this.myLanguages)
        })
        .catch(error => {
          this.$store.commit('setFeedback', error)          
        })

        axios.get('/countries', this.$store.getters.getAxiosConfig)
        .then((response) => {
          this.countries = response.data
          this.myCountries = []
          for(let i = 0; i < this.countries.length; i++) {
            this.myCountries.push( this.countries[i].country_name)
          }
          this.country = this.myCountries[0]
        })
        .catch(error => {
          this.$store.commit('setFeedback', error)          
        })

      },
      getAge() {
        return "Y.of birth: " + this.age
      }
    },
    mounted() {
      this.initData()
    }
  }
</script>
